import Cascader from 'antd/lib/cascader';

export default Cascader;
